module.exports = __webpack_public_path__ + "img/439.c0adddec.jpg";